export function normalizePackageFeatures(features) {
  if (Array.isArray(features)) {
    return features
      .map((feature) => String(feature || '').trim())
      .filter(Boolean);
  }

  if (features && typeof features === 'object') {
    return Object.entries(features)
      .filter(([, enabled]) => enabled)
      .map(([key]) => key.replace(/([A-Z])/g, ' $1').trim())
      .filter(Boolean);
  }

  return [];
}

export function buildFeatureLibrary(packages = [], { excludePackageId, currentFeatures = [] } = {}) {
  const currentSet = new Set(
    currentFeatures.map((feature) => String(feature || '').trim().toLowerCase()).filter(Boolean)
  );

  return packages
    .filter((pkg) => !excludePackageId || pkg.id !== excludePackageId)
    .map((pkg) => {
      const features = normalizePackageFeatures(pkg.features).map((text) => ({
        text,
        alreadyAdded: currentSet.has(text.toLowerCase()),
      }));

      return {
        packageId: pkg.id,
        packageName: pkg.name || 'Unnamed package',
        features,
      };
    })
    .filter((group) => group.features.length > 0);
}

export const PACKAGE_FEATURE_DRAG_TYPE = 'application/x-pkg-feature';
